module.exports = __webpack_public_path__ + "img/fj.2739c665.svg";